var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"lang"},[_c('li',{staticClass:"lang-item"},[_c('a',{staticClass:"lang-link",class:{ 'active': _vm.$store.state.lang == 'es'},attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.selectLang('es')}}},[_vm._v("Español")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f622b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/Lang.vue
// module id = null
// module chunks = 